import { createFileRoute } from "@tanstack/react-router";
import { type } from "arktype";
import { AuthCard } from "@/components/auth/auth-card";
import { Link } from "@/components/ui/link";

const validateSearch = type({
  "error?": "'invalid_token'",
});

export const Route = createFileRoute("/_unauthed/email-verified")({
  component: RouteComponent,
  validateSearch,
});

function RouteComponent() {
  const params = Route.useSearch();
  if (params.error === "invalid_token") {
    return (
      <div className="flex min-h-screen items-center justify-center p-4">
        <AuthCard
          description="Please retry your login, and a new verification email will be sent"
          title="Link Expired"
        >
          <div className="flex justify-end">
            <Link to="/login" variant="default">
              Proceed to login
            </Link>
          </div>
        </AuthCard>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <AuthCard
        description="You can now login to your account"
        title="Email Verified"
      >
        <div className="flex justify-end">
          <Link to="/login" variant="auth">
            Proceed to login
          </Link>
        </div>
      </AuthCard>
    </div>
  );
}
